import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgBasket(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.505 2.94a1 1 0 0 1 1.366.366l2.71 4.696h3.424a1 1 0 1 1 0 2h-.167L20.08 20.085a1 1 0 0 1-.996.917H4.925a1 1 0 0 1-.997-.917L2.171 10.002h-.166a1 1 0 0 1 0-2h3.422l2.712-4.696a1 1 0 0 1 1.732 1L7.737 8.002h8.535l-2.133-3.696a1 1 0 0 1 .366-1.366Zm5.326 7.062H4.178l1.667 9h12.319l1.667-9Zm-7.826 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-4 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm8 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgBasket)
